/* ==========================================================================
   ESENCIA REDESIGN - interactions
   Subtle, elegant motion: scroll reveals, gentle parallax, sticky header
   state, and an auto-duplicating marquee. Vanilla JS, no dependencies.
   Respects prefers-reduced-motion.
   ========================================================================== */
(function () {
  "use strict";

  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal on scroll ------------------------------------------------- */
  function reveal(el) { el.classList.add("is-visible"); }

  function initReveals() {
    var els = document.querySelectorAll("[data-es-reveal]:not(.is-visible)");
    if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(reveal);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -10% 0px" }
    );
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      // Anything already within (or scrolled past) the viewport reveals at once,
      // so deep links, restored scroll positions and fast jumps never leave
      // content stuck invisible. Everything below the fold animates on scroll.
      if (el.getBoundingClientRect().top < vh * 0.9) reveal(el);
      else io.observe(el);
    });
  }

  /* ---- Gentle parallax -------------------------------------------------- */
  function initParallax() {
    if (reduceMotion) return;
    var items = document.querySelectorAll(".es-parallax");
    if (!items.length) return;
    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      items.forEach(function (wrap) {
        var media = wrap.querySelector(".es-parallax__media");
        if (!media) return;
        var rect = wrap.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -0.5..0.5
        var shift = progress * -32; // px
        media.style.transform = "scale(1.12) translate3d(0," + shift.toFixed(2) + "px,0)";
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  /* ---- Sticky header state --------------------------------------------- */
  function initHeaderState() {
    var setState = function () {
      var scrolled = window.scrollY > 40;
      document.documentElement.classList.toggle("es-scrolled", scrolled);
    };
    setState();
    window.addEventListener("scroll", setState, { passive: true });
  }

  /* ---- Marquee (duplicate content for a seamless loop) ------------------ */
  function initMarquee() {
    document.querySelectorAll(".es-marquee__track").forEach(function (track) {
      if (track.dataset.esCloned) return;
      track.dataset.esCloned = "1";
      var html = track.innerHTML;
      track.innerHTML = html + html;
    });
  }

  /* ---- Scroll-linked word illumination ---------------------------------- */
  var wordEls = [];
  function initWordReveal() {
    var els = document.querySelectorAll("[data-es-words]");
    els.forEach(function (el) {
      if (el.dataset.wordsInit) return;
      el.dataset.wordsInit = "1";
      var text = el.textContent.replace(/\s+/g, " ").trim();
      el.textContent = "";
      text.split(" ").forEach(function (w) {
        var span = document.createElement("span");
        span.className = "es-word";
        span.textContent = w;
        el.appendChild(span);
        el.appendChild(document.createTextNode(" "));
      });
      wordEls.push(el);
    });
    if (!wordEls.length) return;
    if (reduceMotion) {
      document.querySelectorAll(".es-word").forEach(function (w) { w.style.opacity = "1"; });
      return;
    }
    updateWords();
    if (!initWordReveal._bound) {
      initWordReveal._bound = true;
      window.addEventListener("scroll", function () { window.requestAnimationFrame(updateWords); }, { passive: true });
      window.addEventListener("resize", function () { window.requestAnimationFrame(updateWords); }, { passive: true });
    }
  }
  function updateWords() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var start = vh * 0.82, end = vh * 0.33;
    wordEls.forEach(function (el) {
      var words = el.getElementsByClassName("es-word");
      var rect = el.getBoundingClientRect();
      var p = (start - rect.top) / (start - end);
      p = Math.max(0, Math.min(1, p));
      var n = words.length;
      for (var i = 0; i < n; i++) {
        var wp = Math.max(0, Math.min(1, p * (n + 6) - i));
        words[i].style.opacity = (0.16 + 0.84 * wp).toFixed(3);
      }
    });
  }

  function init() {
    initReveals();
    initParallax();
    initHeaderState();
    initMarquee();
    initWordReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-run when Shopify theme editor injects/reloads a section.
  document.addEventListener("shopify:section:load", function () {
    initReveals();
    initParallax();
    initMarquee();
    initWordReveal();
  });

  // Safety sweep once everything (images, fonts) has settled.
  window.addEventListener("load", initReveals);
})();
